import { authHeader } from '@/services/auth'
import i18next from 'i18next'
import axios from 'axios'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { buildUriForCall } from '@/helpers/functions/buildUri'

export default {
  namespaced: true,
  state: {
    listDonnees: [],
    definitionDonnees: []
  },
  getters: {
    getDefinitionDonneesListeByCode: (state) => (code) => state.listDonnees.find(donnees => donnees.code === code.toUpperCase()),
    getListDefinitionDonnees: (state) => state.definitionDonnees
  },
  actions: {
    loadDefinitionDonneesListe ({ commit }, payload) {
      const { codes } = payload
      const arrayCodes = codes.map((code) => code.toUpperCase())
      const path = '/definition-donnee-listee'
      const uri = buildUriForCall(path, {
        codes: arrayCodes.toString(),
        lang: i18next.language
      })
      return HTTP_HYPER_ESPACE_BACKEND.get(uri)
        .then((response) => {
          const data = response.data
          commit('setListDonnees', data._embedded.definition_donnee_listee)
        }).catch((error) => {
          console.log({ type: 'error', message: error })
        })
    },
    fetchDefinitionDonnees ({ commit }, payload) {
      let codes = []
      const lang = 'fr'
      if (payload) {
        codes = payload.codes.map((code) => code.toUpperCase())
      }
      return HTTP_HYPER_ESPACE_BACKEND.get(`definition-donnee?codes=${codes.toString()}&lang=${lang}`, {
        headers: authHeader()
      }).then((response) => {
        if (response.status === 200) {
          commit('setDefinitionDonnees', response.data._embedded.definition_donnee)
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mutations: {
    setListDonnees (state, list) {
      state.listDonnees = list
    },
    setDefinitionDonnees (state, list) {
      state.definitionDonnees = list
    }
  }
}
